<template>
  <AnimatePresence>
    <Motion
      v-if="showToolBox"
      :initial="{ x: '100%' }"
      :while-in-view="{ x: 0 }"
      :exit="{ x: '100%' }"
      :transition="{
        type: 'spring',
        stiffness: 100,
        damping: 20,
      }"
      :class="['z-999 fixed bottom-0 right-0', 'flex flex-col', 'shadow-xl']"
    >
      <UTheme :ui="{ button: { base: ['lg:p-4 p-3'], leadingIcon: ['lg:size-6 size-5'] } }">
        <!-- 打开在线客服按钮 -->
        <UTooltip
          :text="t('action.onlineChat')"
          arrow
          :delay-duration="100"
          :content="{
            side: 'left',
            align: 'center',
            sideOffset: 8,
          }"
        >
          <ULink target="_blank" :to="wxChatService">
            <UButton icon="wpf:chat" />
          </ULink>
        </UTooltip>

        <USeparator />

        <!-- 回顶按钮 -->
        <UTooltip
          :text="t('action.toTop')"
          arrow
          :delay-duration="100"
          :content="{
            side: 'left',
            align: 'center',
            sideOffset: 8,
          }"
        >
          <UButton icon="bx:arrow-from-bottom" @click="scrollToTop()" />
        </UTooltip>
      </UTheme>
    </Motion>
  </AnimatePresence>
</template>

<script lang="ts" setup>
  const { t } = useI18n()
  const appConfig = useRuntimeConfig().public
  const { configSite } = useConfigStatic()

  /** 微信客服链接 */
  const wxChatService = appConfig.wxChatService
  /** 是否显示回顶按钮 */
  const showToolBox = ref<boolean>(false)

  const lenis = useLenis(instance => {
    const shouldShow =
      instance.scroll > configSite.SHOW_TOOLBOX_THRESHOLD &&
      !instance.isScrolling &&
      !instance.isTouching
    if (showToolBox.value !== shouldShow) {
      showToolBox.value = shouldShow
    }
    // useDPrint('lenis toolbox', instance)
  })

  /** 滚动到顶部 */
  const scrollToTop = () => {
    lenis.value?.scrollTo(0)
  }
</script>
